import { render, staticRenderFns } from "./Anamnesebogen.vue?vue&type=template&id=28264a52&scoped=true"
import script from "./Anamnesebogen.vue?vue&type=script&lang=js"
export * from "./Anamnesebogen.vue?vue&type=script&lang=js"
import style0 from "./Anamnesebogen.vue?vue&type=style&index=0&id=28264a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28264a52",
  null
  
)

export default component.exports